module.exports = __webpack_public_path__ + "static/media/invoice-icon.bc1199c0.svg";